import { useState, useMemo } from 'preact/hooks';

/**
 * useToggle is a state toggle hook
 *
 * @param defaultValue
 * @returns
 */

export function useToggle(defaultValue = false) {
  const [bool, setBool] = useState(defaultValue);
  const toggleHandlers = useMemo(() => {
    return {
      toggle: () => setBool((x) => !x),
      setTrue: () => setBool(true),
      setFalse: () => setBool(false)
    };
  }, [setBool]);

  return {
    bool,
    ...toggleHandlers
  };
}
